export default {"src":"/_next/static/media/telegram-2.2b94b2ea.svg","height":97,"width":242,"blurWidth":0,"blurHeight":0};